export default {
      id: "download_file-usage",
      viewBox: "0 0 18 21",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#download_file",
      toString: function () {
        return this.url;
      }
    }